import React, { useState } from 'react';
import {
    Container,
    Button,
    List,
    ListItem,
    Box,
    AppBar,
    // Link,
    useMediaQuery,
    useTheme,
    Stack,
    ImageList,
    ImageListItem,
    ListItemIcon,
    Menu,
    MenuItem
} from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// import MobileNav from '../MobileNav/MobileNav';
import SmsIcon from '../../assets/icons/SmsIcon';
import MenuIcon from '../../assets/icons/MenuIcon';
import JobFactorIcon from '../../assets/icons/JobFactorIcon';
import CloseIcon from '../../assets/icons/CloseIcon';
import { useAppDispatch } from '../../Feature/Store/Store';
import { openSignupModalState } from '../../Feature/App/AppSlice';
import BasicModal from '../CommunityModal/CommunityModal';
import SideMenuArrowDown from '../../assets/icons/SideMenuArrowDown';
import MobileNav from '../MobileNavLanding/MobileNav';
import logo from '../../assets/Images/logo.webp';

const Navbar = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [menu, setMenu] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [isHover, setIsHover] = useState(false);

    const [subMenuItems, setSubMenuItems] = useState<any>([]);
    const handleOpen = () => setOpen(true);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const handleClick = (event: any, menu: any) => {
        setAnchorEl(event.currentTarget);
        if (menu.length > 0) setSubMenuItems(menu);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const subNavItems = [
        {
            name: 'About Jobfactor',
            location: '/about'
        },
        {
            name: 'How Jobfactor works',
            location: '/how-jobfactor-works'
        }
    ];
    // List of nav items
    const navItems = [
        {
            name: 'FIND A JOB',
            href: '/create-account/professional'
        },
        {
            name: 'HIRE TALENT',
            href: '/create-account/company'
        },
        {
            name: 'ABOUT US',
            icon: <SideMenuArrowDown />,
            subMenu: subNavItems,
            location: '/about'
        },
        { name: 'BLOG', location: '/blog' },
        { name: 'COMMUNITY' }
    ];

    const theme = useTheme();

    // Responsive navbar for mobile devices
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

    // Style for nav items
    const navText = {
        fontSize: '16px',
        cursor: 'pointer',
        transition: 'all .4s ease',
        '&:hover': { textDecoration: 'underline', color: 'primaryDark.main' }
    };

    // Style for nav items when they are clicked to be added later in project
    const onAction = {
        color: '#23282B',
        cursor: 'pointer',
        fontWeight: 700
    };

    const handleLinks = (item: any, evt: any, index: any) => {
        evt.preventDefault();
        console.log(evt);
        console.log(item);
        console.log(index);
    };

    return (
        <AppBar
            position="fixed"
            color="transparent"
            sx={{
                boxShadow: 'none',
                background: `linear-gradient(255deg, #f1fbff 0%, #fff3f5 100%)`
            }}
        >
            <Container
                sx={{
                    position: 'relative',
                    px: isMobile ? '16px' : '60px'
                }} // left and right padding changes when breakpoint is 'lg'
                maxWidth="xl"
                disableGutters
            >
                <Stack
                    sx={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: {
                            xs: 'space-between',
                            sm: 'flex-start',
                            lg: 'space-between'
                        },
                        height: isMobile ? null : '100px',
                        py: '12px'
                    }}
                >
                    {/* <ImageList
                        onClick={() => {
                            setMenu(false);
                            navigate('/');
                        }}
                        sx={{
                            transition: 'all .4s ease',
                            cursor: 'pointer',
                            '&:hover': {
                                opacity: 0.8
                            }
                        }}
                        cols={1}
                    >
                        <ImageListItem>
                            <img src={logo} alt="logo" />
                        </ImageListItem>
                    </ImageList> */}
                    <JobFactorIcon />
                    <>
                        <Box
                            sx={{
                                display: { xs: 'none', lg: 'flex' },
                                gap: '20px',
                                justifyContent: 'center'
                            }}
                        >
                            {/* {navItems.map(
                                    (
                                        item // Mapping through list of nav items
                                    ) => (
                                        <List key={item.name}>
                                            <ListItem
                                                disablePadding
                                                sx={{
                                                    maxWidth: 'content',
                                                    alignItems: 'center',
                                                    ml: item.icon
                                                        ? '8px'
                                                        : '16px',
                                                    mr: item.icon
                                                        ? '8px'
                                                        : '16px'
                                                }}
                                            >
                                                <Link
                                                    onClick={() => {
                                                        item.name !==
                                                        'COMMUNITY'
                                                            ? navigate(
                                                                  item.location ??
                                                                      ''
                                                              )
                                                            : handleOpen();
                                                    }}
                                                    rel="noopener"
                                                    component="button"
                                                    // href={item?.location}
                                                    variant="body1"
                                                    underline="none"
                                                    color="navTextColor.main"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}
                                                    sx={
                                                        location.pathname ===
                                                            item.location ||
                                                        location.pathname.includes(
                                                            item.name.toLocaleLowerCase()
                                                        )
                                                            ? onAction
                                                            : navText
                                                    }
                                                >
                                                    {item.name}
                                                </Link>
                                                {item.icon ? (
                                                    <ListItemIcon
                                                        onClick={(evt) => {
                                                            if (item.subMenu)
                                                                handleClick(
                                                                    evt,
                                                                    item.subMenu
                                                                );
                                                        }}
                                                        sx={{
                                                            minWidth: '24px',
                                                            cursor: 'pointer',
                                                            ml: '8px'
                                                        }}
                                                    >
                                                        {item.icon}
                                                    </ListItemIcon>
                                                ) : null}
                                            </ListItem>
                                        </List>
                                    )
                                )} */}

                            {navItems.map(
                                (
                                    item,
                                    index // Mapping through list of nav items
                                ) => (
                                    <List key={item.name}>
                                        <ListItem
                                            disablePadding
                                            sx={{
                                                maxWidth: 'content',
                                                alignItems: 'center',
                                                ml: item.icon ? '8px' : '16px',
                                                mr: item.icon ? '8px' : '16px'
                                            }}
                                        >
                                            <a
                                                key={item.name}
                                                href={
                                                    item.location ?? item.href
                                                }
                                                onClick={(evt) => {
                                                    // handleLinks(item, evt, index);
                                                    console.log(
                                                        item,
                                                        evt,
                                                        index
                                                    );
                                                    item.name !== 'COMMUNITY'
                                                        ? navigate(
                                                              item.location ??
                                                                  ''
                                                          )
                                                        : handleOpen();
                                                }}
                                                onMouseEnter={() =>
                                                    setIsHover(true)
                                                }
                                                onMouseLeave={() =>
                                                    setIsHover(false)
                                                }
                                                rel="noreferrer"
                                                target={
                                                    item.href
                                                        ? '_blank'
                                                        : '_top'
                                                }
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    color: '#808080',
                                                    textDecoration: 'none',
                                                    fontSize: '16px',
                                                    cursor: 'pointer',
                                                    transition: 'all .4s ease'
                                                    //
                                                    // textDecoration: isHover ? 'underline' : 'none',
                                                    // color: isHover ? 'primaryDark.main' : 'navTextColor.main'
                                                }}
                                            >
                                                {item.name}
                                            </a>
                                            {/* <Link
                                                    onClick={(evt) => {
                                                        handleLinks(item, evt, index);
                                                    }}
                                                    rel="noopener"
                                                    to={{ pathname: item.location ?? undefined }}
                                                    target={"_blank"}
                                                    // href={item?.location}
                                                    // variant="body1"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        color: "navTextColor.main",
                                                        textDecoration: 'none',
                                                        fontSize: '16px',
                                                        cursor: 'pointer',
                                                        transition: 'all .4s ease',
                                                        '&:hover': { textDecoration: 'underline', color: 'primaryDark.main' }
                                                    }}
                                                    // sx={
                                                    //     // location.pathname ===
                                                    //     //     item.location ||
                                                    //     // location.pathname.includes(
                                                    //     //     item.name.toLocaleLowerCase()
                                                    //     // )
                                                    //     //     ? onAction
                                                    //     //     : navText
                                                    // }
                                                >
                                                    {item.name}
                                                </Link> */}
                                            {item.icon ? (
                                                <ListItemIcon
                                                    // onClick={(evt) => {
                                                    //     if (item.subMenu)
                                                    //         handleClick(
                                                    //             evt,
                                                    //             item.subMenu
                                                    //         );
                                                    // }}
                                                    sx={{
                                                        minWidth: '24px',
                                                        cursor: 'pointer',
                                                        ml: '8px'
                                                    }}
                                                    onClick={(e) => {
                                                        if (item.subMenu)
                                                            handleClick(
                                                                e,
                                                                item.subMenu
                                                            );
                                                    }}
                                                >
                                                    {item.icon}
                                                </ListItemIcon>
                                            ) : null}
                                        </ListItem>
                                    </List>
                                )
                            )}
                        </Box>
                        <Box
                            flex={1}
                            sx={{ justifyContent: 'flex-end' }}
                            display={{ xs: 'none', sm: 'flex', lg: 'none' }}
                        >
                            <Link to="/create-account" rel="noopener">
                                <Button
                                    sx={{
                                        gap: '12px',
                                        padding: '16px 52px',
                                        borderRadius: '100px',
                                        fontWeight: 600,
                                        lineHeight: '24px',
                                        letterSpacing: '0.024px',
                                        textTransform: 'uppercase',
                                        fontFamily: 'Outfit',
                                        fontSize: '16px',
                                        marginRight: '12px'
                                    }}
                                    variant="contained"
                                    color="primary"
                                >
                                    Sign Up
                                </Button>
                            </Link>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                margin: '6px',
                                alignItems: 'center'
                            }}
                        >
                            <Box sx={{}} display={{ xs: 'none', lg: 'block' }}>
                                <Link to="/create-account" rel="noopener">
                                    <Button
                                        sx={{
                                            gap: '12px',
                                            padding: '16px 52px',
                                            borderRadius: '100px',
                                            fontWeight: 600,
                                            lineHeight: '24px',
                                            letterSpacing: '0.024px',
                                            textTransform: 'uppercase',
                                            fontFamily: 'Outfit',
                                            fontSize: '16px',
                                            marginRight: '12px'
                                        }}
                                        variant="contained"
                                        color="primary"
                                    >
                                        Sign Up
                                    </Button>
                                </Link>
                            </Box>
                            <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
                                <Link to="/login" rel="noopener">
                                    <Button
                                        sx={{
                                            gap: '12px',
                                            padding: '16px 52px',
                                            borderRadius: '100px',
                                            fontWeight: 600,
                                            lineHeight: '24px',
                                            letterSpacing: '0.024px',
                                            textTransform: 'uppercase',
                                            fontFamily: 'Outfit',
                                            fontSize: '16px'
                                        }}
                                        variant="outlined"
                                        color="primary"
                                    >
                                        Login
                                    </Button>
                                </Link>
                            </Box>
                        </Box>
                    </>
                    <Box
                        sx={{ display: { xs: 'block', lg: 'none' } }}
                        onClick={() => setMenu(true)}
                    >
                        <MenuIcon />
                    </Box>
                </Stack>
                {menu && isMobile ? (
                    <MobileNav setMenu={setMenu} menu={menu} />
                ) : null}
            </Container>
            <BasicModal open={open} setOpen={setOpen} />
            <Menu
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                // MenuProps={{
                //     // getContentAnchorEl: null,
                // }}
            >
                {subMenuItems.map((item: any, i: number) => (
                    <MenuItem
                        key={i}
                        sx={{
                            '&:hover': {
                                color: '#23282b',
                                bgcolor: '#EDEDED',
                                fontWeight: 600
                            }
                        }}
                        onClick={() => {
                            handleClose();
                            navigate(item.location);
                        }}
                    >
                        {item.name}
                    </MenuItem>
                ))}
            </Menu>
        </AppBar>
    );
};

export default Navbar;
